import { Root } from '@radix-ui/react-label';
import { forwardRef, type ElementRef } from 'react';

import { cn } from '@/shared/utils/cn/cn.util';

import { type LabelProps } from './Label.types';

export const Label = forwardRef<ElementRef<typeof Root>, LabelProps>(function Label(
  { className, isRequired = false, children, ...props },
  ref,
) {
  return (
    <Root
      ref={ref}
      className={cn(
        'inline-flex items-center gap-xs text-label text-foreground',
        // A label whose control is disabled must look disabled too, or the form
        // reads as half-enabled. Radix sets `data-disabled` on the group.
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-60',
        className,
      )}
      {...props}
    >
      {children}
      {isRequired ? (
        <span aria-hidden="true" className="text-destructive">
          *
        </span>
      ) : null}
    </Root>
  );
});
